'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Card, Form, Button } from 'react-bootstrap';

const ValidateUtil = require('../../util/ValidateUtil');
const RegisterActions = require('../../actions/RegisterActions');
const RegisterStore = require('../../stores/register_store_reflux');
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';

const propTypes = {};
const defaultProps = {};

class AdminInviteUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email1: "",
            email2: "",
            hasError: false,
            message: "",
            submissionSuccess: false,
            actionID: null,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.email1OnChange = this.email1OnChange.bind(this);
        this.email2OnChange = this.email2OnChange.bind(this);
        this.registerHandler = this.registerHandler.bind(this);
        this.unsubscribes = [
            RegisterStore.listen(this.onRegisterStoreStateChange.bind(this))
        ];
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.actionID && !this.state.actionID && this.state.actionSuccess) {
            this.setState({
                submissionSuccess: true,
                message: "Invitation email sent."+ " ("+this.state.email1+")",
                email1: "",
                email2: ""
            });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onRegisterStoreStateChange(newState) {
        let updatedState = ValidateUtil.getUpdatedState(this.state.actionID, newState);
        this.setState(updatedState);
    }

    email1OnChange(e) {
        this.setState({ email1: e.target.value });
    }

    email2OnChange(e) {
        this.setState({ email2: e.target.value });
    }

    registerHandler() {
        const actionID = uuid.v4();
        this.setState({ actionID: actionID, submissionSuccess: false }, () => {
            RegisterActions.registerEmail(actionID, {
                email1: this.state.email1,
                email2: this.state.email2
            });
        });
    }

    render() {
        return (
            <Card body bg="light">
                <ErrorBox error={this.state.error} />
                {(this.state.submissionSuccess) && <SuccessBox message={this.state.message}/>}

                <Form>
                    <Form.Group controlId="admin-invite-email1">
                        <Form.Label>email address:</Form.Label>
                        <Form.Control
                            type="text"
                            aria-label="email address"
                            value={this.state.email1}
                            onChange={this.email1OnChange}
                            onKeyDown={this.handleKeyDown}
                            isInvalid={ValidateUtil.isInvalid(this.state, 'email1')}
                        />
                    </Form.Group>
                    <Form.Group controlId="admin-invite-email2">
                        <Form.Label>confirm email:</Form.Label>
                        <Form.Control
                            type="text"
                            aria-label="confirm email"
                            value={this.state.email2}
                            onChange={this.email2OnChange}
                            onKeyDown={this.handleKeyDown}
                            isInvalid={ValidateUtil.isInvalid(this.state, 'email2')}
                        />
                    </Form.Group>
                    <Button
                        disabled={this.state.actionID}
                        onClick={this.registerHandler}
                    >
                        register
                    </Button>
                </Form>
            </Card>
        );
    }
}

AdminInviteUser.propTypes = propTypes;
AdminInviteUser.defaultProps = defaultProps;

export default AdminInviteUser;
